import { CeilingTray, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const CeilingTraySchema = new ModelSchema<CeilingTray>('ceilingTray', {
  category: ModelCategory.IntermediateModel,

  properties: {},
  children: {},
});
